import { Html } from '@react-three/drei';
import { ControlContext } from 'provider/ControlProvider';
import ReactPlayer from 'react-player';
import { useContext } from 'react';
import { TvIcon } from '@heroicons/react/20/solid';

type Props = {
  name?: string;
  pos?: Array<number>;
  url?: string;
  index?: number;
};

const Video = ({
  name = 'Unknown',
  pos = [0, 0, 0],
  url = '/video/chapter1.mp4',
  index = 0,
}: Props) => {
  const { setContent } = useContext(ControlContext);
  return (
    <Html scale={0.5} transform name={name} position={[pos[0], pos[1], pos[2]]}>
      <div className='w-80 flex flex-col items-center justify-center '>
        <ReactPlayer url={url} controls={true} width={320} height={200} />
      </div>
    </Html>
  );
};

export default Video;
